/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */

/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  Button,
  Combobox,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  FormField,
  FormControl,
  FormItem,
  Input as DefaultInput,
  Form,
  DatePicker,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Badge,
  Checkbox,
} from "@repo/ui";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  useDeleteSearchCriteria,
  useGetSavedCriteria,
  useGetSavedCriteriaDetails,
  useGetTicketsConfig,
  useSaveTicketsQuery,
  useUpdateSearchCriteriaSequence,
} from "services/dynamic-filtering";
import {
  useLookupActivityTypes,
  useLookupAllAssignmentGroups,
  useLookupCashCenters,
  useLookupCustomers,
  useLookupResolutionCodes,
  useLookupTicketStatuses,
  useLookupAllRoute,
  useLookupTasksStatuses,
  useLookupPendingReasons,
} from "services/lookups";
import Loader from "ui/page-loader";
import { Loader as KendoLoader } from "@progress/kendo-react-indicators";
import {
  CircleX,
  Plus,
  RefreshCcw,
  SlidersHorizontal,
  Trash2,
} from "lucide-react";
import { useFieldArray, useForm } from "react-hook-form";
import { Label } from "ui/label";
import { useUser } from "hooks/use-user";
import {
  useGetEmployees,
  useGetFieldTeam,
  useGetUserByRoles,
} from "services/auth";
import moment from "moment";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useNavigate, useParams } from "react-router-dom";
import { PATHS } from "routes/paths";
import eventBus from "store/event-emitter";
import { client } from "services/api-client";
import ColumnsSettings from "./columns-settings";
import { FaFileExcel } from "react-icons/fa";
import { getLocalISODateString } from "utils/date-utils";
import KendoMultiselect from "ui/multiselect";
import { isCallCenterAgent } from "pages/tickets/utils";
import BulkAssignment from "./bulk-assignment";
import SearchCriteriaSettings from "./search-criteria-sequence";

const LOGICS = [
  { id: "equal", text: "Equal" },
  { id: "not_equal", text: "Not Equal" },
  { id: "like", text: "Like" },
  { id: "not_like", text: "Not Like" },
  { id: "in", text: "In" },
  { id: "not_in", text: "Not In" },
  { id: "gt", text: "Greater Than" },
  { id: "gte", text: "Greater Than or Equal" },
  {
    id: "lt",
    text: "Less Than",
  },
  { id: "lte", text: "Less Than or Equal" },
  { id: "between", text: "Between" },
];

const periodList = [
  { label: "Today", value: "today" },
  { label: "All", value: "all" },
  { label: "Yesterday", value: "yesterday" },
  { label: "This Week", value: "thisweek" },
  { label: "Last Week", value: "lastweek" },
  { label: "This Month", value: "thismonth" },
  { label: "Last Month", value: "lastmonth" },
  { label: "Last 6 Months", value: "last6months" },
  { label: "Last 9 Months", value: "last9months" },
  { label: "Last 12 Months", value: "last12months" },
  { label: "This Quarter", value: "thisquarter" },
  { label: "last Quarter", value: "lastquarter" },
  { label: "Last 2 Quarter", value: "last2quarter" },
  { label: "Last Hour", value: "lasthour" },
  { label: "Last 2 Hour", value: "last2hour" },
  { label: "Current Minute", value: "currentminute" },
  { label: "Last Minute", value: "lastminute" },
  { label: "Last 15 Minute", value: "last15minute" },
  { label: "Last 30 Minute", value: "last30minute" },
  { label: "Last 45 Minute", value: "last45minute" },
];
export default function DynamicFiltering({
  setFilters = () => {},
  exportExcel = false,
  exportingExcel = false,
  onExcelExport = () => {},
  onRefresh = () => {},
  selectedRequests = [],
  assignTeam = () => {},
  hideSupervisor = false,
  isSecondaryAssigneeRequired = false,
}) {
  const [filtersConfigurations, setFiltersConfigurations] = useState({});
  const [fieldTeam, setFieldTeam] = useState([]);
  const [logicObj, setLogicObj] = useState({
    equal: "Equal",
    not_equal: "Not Equal",
    like: "Like",
    not_like: "Not Like",
    in: "In",
    not_in: "Not In",
    gt: "Greater Than",
    gte: "Greater Than or Equal",
    lt: "Less Than",
    lte: "Less Than or Equal",
    between: "Between",
  });
  const [selectedCriteria, setSelectedCriteria] = useState(null);
  const [locationsList, setLocationsList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const filtersModified = useRef(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedDate, setSelectedDate] = useState("today");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const filterTimeout = useRef(null);
  const filtersRef = useRef(null);
  const params = useParams();
  const user = useUser();
  const isSLMEngineer = user.Roles.includes("SLM Engineer Dispatcher");
  const navigate = useNavigate();
  const isCCA = isCallCenterAgent(user) || user.Roles.includes("CSM Agent");
  const ticketsType = isCCA ? "allcalls" : "tasks";
  const locationsListRef = useRef([]);
  const categoriesListRef = useRef([]);
  const subCategoriesListRef = useRef([]);

  const { mutate: getCashCenters, data: cashCentersList } =
    useLookupCashCenters();
  const { mutate: getCustomers, data: customersList } = useLookupCustomers();
  const { mutate: getActivityTypes, data: activityTypesRes } =
    useLookupActivityTypes();
  const { mutate: getResolutionCodes, data: resolutionCodesRes } =
    useLookupResolutionCodes();
  const { mutate: getReasons, data: reasonsRes } = useLookupPendingReasons();
  const {
    mutate: getTicketStatusList,
    data: ticketStatusList,
    reset: resetTicketStatusList,
  } = useLookupTicketStatuses();
  const {
    mutate: getTaskStatusList,
    data: taskStatusList,
    reset: resetTaskStatusList,
  } = useLookupTasksStatuses();
  const { mutate: getUsersList, data: usersListRes } = useGetUserByRoles();

  const { mutate: getRoutes, data: routesList } = useLookupAllRoute();
  const { mutate: getAssignmentGroups, data: assignmentGroupsRes } =
    useLookupAllAssignmentGroups();
  const {
    mutate: getUsers,
    data: usersList,
    reset: resetUsersList,
  } = useGetEmployees();
  const { mutate: getDispatchers, data: dispatchersList } = useGetEmployees();
  const {
    mutate: getFieldTeam,
    data: fieldTeamList,
    reset: resetFieldTeam,
  } = useGetFieldTeam();
  const {
    mutate: getTicketsConfig,
    data: ticketsConfig,
    isPending: gettingTicketsConfig,
    reset: resetGetTicketsConfig,
  } = useGetTicketsConfig();
  const {
    mutate: saveTicketsQuery,
    data: saveTicketsQueryRes,
    isPending: savingTicketsQuery,
    reset: resetSaveTicketsQuery,
  } = useSaveTicketsQuery();
  const {
    mutate: getSaveCriteria,
    data: savedCriteria,
    isPending: gettingSavedCriteria,
  } = useGetSavedCriteria();

  const {
    mutate: deleteSearchCriteria,
    data: deleteSearchCriteriaRes,
    isPending: deletingSearchCriteria,
    reset: resetDeleteSearchCriteria,
  } = useDeleteSearchCriteria();

  const {
    mutate: getSaveCriteriaDetails,
    data: savedCriteriaDetails,
    isPending: gettingSavedCriteriaDetail,
    reset: resetSavedCriteriaDetail,
  } = useGetSavedCriteriaDetails();
  const {
    mutate: updateSequence,
    data: updateSequenceRes,
    isPending: updatingSequence,
    reset: resetUpdateSequence,
  } = useUpdateSearchCriteriaSequence();

  const form = useForm({
    defaultValues: {
      searchName: "",
      operations: [],
      saveForUser: true,
      saveForOthers: false,
    },
  });

  const defaultQuery = {
    logic: "and",
    field: "",
    operator: "equal",
    value: "",
  };
  const operationsForm = useForm({
    defaultValues: { ...defaultQuery, operations: [] },
  });
  const { fields } = useFieldArray({
    control: operationsForm.control, // control props comes from useForm (optional: if you are using FormProvider)
    name: "operations", // unique name for your Field Array
  });
  useEffect(() => {
    filtersRef.current = fields;
  }, [fields]);

  useEffect(() => {
    locationsListRef.current = locationsList;
  }, [locationsList]);
  useEffect(() => {
    categoriesListRef.current = categoryList;
  }, [categoryList]);
  useEffect(() => {
    subCategoriesListRef.current = subCategoryList;
  }, [subCategoryList]);
  useEffect(() => {
    getTicketsConfig(ticketsType);
    getCashCenters();
    getCustomers();
    getActivityTypes();
    getAssignmentGroups();
    getSaveCriteria(ticketsType);
    getResolutionCodes();
    if (isCCA) {
      getTicketStatusList();
    } else {
      getTaskStatusList();
      getReasons("Maintenance");
      getRoutes();
      getDispatchers(
        isSLMEngineer ? ["SLM Engineer Dispatcher"] : ["Call Out Dispatcher"],
      );
      if (isSLMEngineer) {
        getUsers("SLM Engineer");
      } else {
        getFieldTeam();
      }
    }
    getUsersList(
      isCCA
        ? ["Call Center Agent", "CC Calls", "CCA Reader", "CC Dashboard"]
        : isSLMEngineer
          ? ["SLM Engineer Dispatcher"]
          : ["Call Out Dispatcher"],
    );

    const actionEventHandler = (payload) => {
      if (payload?.type === "filter" || payload?.type === "matching") {
        const _filters = [...(filtersRef.current || [])];
        _filters.push({
          logic: "and",
          operator: payload?.type === "filter" ? "not_equal" : "equal",
          field: payload.field,
          value: payload.value,
          name: payload.name,
          label: payload.label,
        });
        operationsForm.setValue("operations", _filters);
        filterQueries(_filters);
      }
    };
    eventBus.on("applyActions", actionEventHandler);
    const resetPeriodHandler = () => {
      setSelectedDate("today");
    };
    return () => {
      eventBus.off("applyActions", actionEventHandler);
      eventBus.off("resetPeriod", resetPeriodHandler);
    };
  }, []);

  useEffect(() => {
    if (params && params.searchId && savedCriteria) {
      getSaveCriteriaDetails(params.searchId);
      setSelectedCriteria(params.searchId);
      setSelectedDate("today");
      const currentCriteria = savedCriteria?.data.find(
        (elm) => elm.id === params.searchId,
      );
      if (currentCriteria) {
        form.setValue("searchName", currentCriteria.searchName);
      }
    }
  }, [params, savedCriteria]);

  const restoreSavedFilters = async () => {
    const _queries = [];
    const locationPromises = [];
    const categoryPromises = [];
    const subCategoryPromises = [];
    const _logicObj = { ...logicObj };
    setLoading(true);
    form.setValue(
      "saveForOthers",
      savedCriteriaDetails.data.isSharedWithUsers ||
        savedCriteriaDetails.data.isSharedWithAssignmentGroups,
    );

    savedCriteriaDetails.data.filters.forEach((elm) => {
      const currentField = filtersConfigurations.filters.find(
        (filter) => elm.field === filter.field,
      );
      currentField?.allowedOperators.forEach((elm) => {
        _logicObj[elm.value] = elm.display;
      });

      const label = currentField?.label || elm.value;
      const fieldData = {
        logic: elm.logic,
        operator: elm.operator,
        field: elm.field,
        label,
        name: elm.text || elm.value,
        value:
          elm.operator === "in" ||
          elm.operator === "not_in" ||
          elm.operator === "between"
            ? typeof elm.value === "string"
              ? [elm.value]
              : elm.value
            : elm.value,
        dependency: null,
      };

      _queries.push(fieldData);

      if (currentField?.field === "CustomerId" && currentField?.value) {
        const locationPromise = client(
          `lookups/customer/machine/sites/all/${elm.value}`,
        ).then((res) =>
          res.data.map((location) => ({
            ...location,
            customerId: elm.value,
          })),
        );
        locationPromises.push(locationPromise);
      } else if (
        (currentField?.field === "ActivityType" ||
          currentField.field === "ServiceType") &&
        currentField?.value
      ) {
        const categoryPromise = client(
          `lookups/activity/categories/${elm.value}`,
        ).then((res) =>
          res.data.map((category) => ({
            ...category,
            activityType: elm.value,
          })),
        );
        categoryPromises.push(categoryPromise);
      }
    });

    const locationResults = await Promise.all(locationPromises);
    const _locationsList = locationResults.flat();

    const categoryResults = await Promise.all(categoryPromises);
    const _categoryList = categoryResults.flat();
    _categoryList.forEach((category) => {
      const categorySelected = savedCriteriaDetails.data.filters.find(
        (elm) => elm.field === "Category" && elm.value === category.description,
      );
      if (categorySelected) {
        const subCategoryPromise = client(
          `lookups/activity/sub/categories/${category.activityType}/${category.description}`,
        ).then((res) =>
          res.data.map((subCategory) => ({
            ...subCategory,
            activityType: category.activityType,
            category: category.description,
          })),
        );
        subCategoryPromises.push(subCategoryPromise);
      }
    });

    const subCategoryResults = await Promise.all(subCategoryPromises);
    const _subCategoryList = subCategoryResults.flat();
    setLogicObj(_logicObj);
    setCategoryList(_categoryList);
    setSubCategoryList(_subCategoryList);
    setLocationsList(_locationsList);
    operationsForm.reset({ ...defaultQuery, operations: _queries });
    filterQueries(_queries);
    resetSavedCriteriaDetail();
    setLoading(false);
  };
  const resetPage = () => {
    setSelectedCriteria("");
    setSelectedDate("today");
    form.reset();
    operationsForm.reset({ ...defaultQuery, operations: [] });
    setIsEditing(false);
    setCategoryList([]);
    setSubCategoryList([]);
    setLocationsList([]);
    setFilters({
      filters: [],
      period: "today",
      searchString: selectedFilter,
    });
  };

  const CCAAssignmentGroups = [
    "Call Center",
    "Cash Admin",
    "Planning & Analysis",
    "Security & Compliance",
    "EK Outsource",
    "Fleet Management",
    "Business Development",
    "TG Cash Customer Service",
    "CS Monitoring",
  ];
  const dispatcherAssignmentGroups = [
    "FLM-Dubai",
    "FLM-Abu Dhabi",
    "FLM-Al Ain",
    "FLM-Northern Emirates",
    "SLM-Gunnebo",
    "FE-Cheque Collection Team Dubai",
    "Cash Operations-Abu Dhabi",
    "Cash Operations-Dubai",
    "Cash Operations-Al Ain",
    "Cash Operations-Northern Emirates",
    "CMC Operations-Dubai",
    "CMC Operations-Abu Dhabi",
  ];

  const getOtherAssignmentGroups = useMemo(() => {
    const assignmentGroups = isCCA
      ? CCAAssignmentGroups
      : dispatcherAssignmentGroups;
    const filteredGroups = (assignmentGroupsRes?.data || [])
      .filter((elm) => {
        if (assignmentGroups.includes(elm.name)) {
          return true;
        }
        return false;
      })
      .map((elm) => ({ label: elm.name, value: elm.name }));
    return filteredGroups;
  }, [assignmentGroupsRes]);

  const getAssignmentGroupsList = useMemo(() => {
    const filteredGroups = (assignmentGroupsRes?.data || [])
      .filter((elm) => !["Administrator", "Customer"].includes(elm.name))
      .map((elm) => ({ label: elm.name, value: elm.name }));
    return filteredGroups;
  }, [assignmentGroupsRes]);

  useEffect(() => {
    if (usersList) {
      setFieldTeam(usersList?.data);
      resetUsersList();
    }
    if (fieldTeamList) {
      setFieldTeam(fieldTeamList?.data || []);
      resetFieldTeam();
    }

    if (savedCriteriaDetails && filtersConfigurations?.filters) {
      restoreSavedFilters();
    }

    if (saveTicketsQueryRes) {
      eventBus.emit("refreshFavorites", {
        message: "Kindly refresh Favorites",
      });

      setIsOpen(false);
      getSaveCriteria(ticketsType);
      const currentItem = Array.isArray(saveTicketsQueryRes?.data)
        ? saveTicketsQueryRes?.data?.find((elm) => elm.userId === user.UserId)
        : null;

      if (currentItem?.searchCriteriaId) {
        navigate(`${getBaseUrl}/${currentItem.searchCriteriaId}`);
      } else if (selectedCriteria) {
        navigate(`${getBaseUrl}/${selectedCriteria}`);
      } else {
        navigate(`${getBaseUrl}`);
      }
      resetPage();
      resetSaveTicketsQuery();
    }
    if (updateSequenceRes) {
      eventBus.emit("refreshFavorites", {
        message: "Kindly refresh Favorites",
      });
      getSaveCriteria(ticketsType);
      resetUpdateSequence();
      if (selectedCriteria) {
        navigate(`${getBaseUrl}/${selectedCriteria}`);
      } else {
        navigate(`${getBaseUrl}`);
      }
    }
    if (deleteSearchCriteriaRes) {
      eventBus.emit("refreshFavorites", {
        message: "Kindly refresh Favorites",
      });
      setIsOpen(false);
      getSaveCriteria(ticketsType);
      resetPage();
      resetDeleteSearchCriteria();
      setSelectedCriteria("");
      navigate(`${getBaseUrl}`);
    }
    if (ticketStatusList) {
      setStatusList(ticketStatusList?.data || []);
      resetTicketStatusList();
    }
    if (taskStatusList) {
      setStatusList(taskStatusList?.data || []);
      resetTaskStatusList();
    }
  }, [
    usersList,
    fieldTeamList,
    savedCriteriaDetails,
    cashCentersList,
    customersList,
    saveTicketsQueryRes,
    deleteSearchCriteriaRes,
    updateSequenceRes,
    ticketStatusList,
    taskStatusList,
  ]);
  useEffect(() => {
    if (ticketsConfig) {
      setFiltersConfigurations(ticketsConfig.data);
      resetGetTicketsConfig();
    }
  }, [ticketsConfig]);
  const getBaseUrl = isCCA
    ? PATHS.allServiceAndNonServiceCalls
    : PATHS.dynamicFiltering;
  const saveCriteria = (data) => {
    const basePayload = {
      searchName: data.searchName,
      sharedWithUserIds:
        data.saveForOthers && data.users
          ? data.users.map((elm) => elm.value)
          : [],
      sharedWithAssignmentGroups:
        data.saveForOthers && data.assignmentGroups
          ? data.assignmentGroups.map((elm) => elm.value)
          : [],
      saveForMe: data.saveForUser,
      screen: ticketsType,
      filters: fields.map((elm) => ({
        field: elm.field,
        logic: elm.logic,
        operator: elm.operator,
        value: elm.value,
        text: elm.name,
      })),
    };
    if (selectedCriteria) {
      basePayload.id = selectedCriteria;
      basePayload.overwrite = true;
    }
    saveTicketsQuery(basePayload);
  };
  const onSubmit = (data) => {
    saveCriteria(data);
  };

  const errors = form.formState.errors;

  useEffect(() => {
    filterQueries();
  }, [selectedDate]);

  useEffect(() => {
    if (selectedFilter !== null) {
      filterTimeout.current = setTimeout(() => {
        filterQueries();

        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }
    };
  }, [selectedFilter]);

  const filterQueries = (queryList) => {
    const filters = [];

    const _queryList = queryList || fields;
    _queryList.forEach((elm) => {
      filters.push({
        logic: elm.logic,
        operator: elm.operator,
        value: elm.value,
        field: elm.field,
        name: elm.name,
        label: elm.label,
      });
    });
    setFilters({
      filters: filters
        .map((elm) => ({
          logic: elm.logic,
          operator: elm.operator,
          value: elm.value,
          field: elm.field,
        }))
        .filter((elm) => elm.value),
      period: selectedDate,
      searchString: selectedFilter,
    });
  };

  const getLocations = async (value) => {
    if (!value) {
      return;
    }
    try {
      const _locationsList = await client(
        `lookups/customer/machine/sites/all/${value}`,
      );

      const updatedLocationsList = [
        ...locationsListRef.current,
        ..._locationsList.data.map((elm) => ({
          ...elm,
          customerId: value,
        })),
      ];
      locationsListRef.current = updatedLocationsList;

      setLocationsList([...updatedLocationsList]);
    } catch (e) {
      console.log("Error", e);
    }
  };
  const getSubCategory = async (activity, category) => {
    if (!activity || !category) {
      return;
    }
    try {
      const _subCategoryList = await client(
        `lookups/activity/sub/categories/${activity}/${category}`,
      );
      const updatedSubCategories = [
        ...subCategoriesListRef.current,
        ..._subCategoryList.data.map((elm) => ({
          ...elm,
          activityType: activity,
          category,
        })),
      ];
      subCategoriesListRef.current = updatedSubCategories;
      setSubCategoryList([...updatedSubCategories]);
    } catch (e) {
      console.log("Error", e);
    }
  };
  const getCategory = async (activity) => {
    if (!activity) {
      return;
    }
    try {
      const _categoryList = await client(
        `lookups/activity/categories/${activity}`,
      );
      const updatedCategoriesList = [
        ...categoriesListRef.current,
        ..._categoryList.data.map((elm) => ({
          ...elm,
          activityType: activity,
        })),
      ];
      categoriesListRef.current = updatedCategoriesList;
      setCategoryList([...updatedCategoriesList]);
    } catch (e) {
      console.log("Error", e);
    }
  };

  const addQuery = async (data) => {
    const queryFields = [...fields];
    const valueArray = Array.isArray(data.value)
      ? data.value
      : [{ value: data.value }];

    const field = JSON.parse(data.field);
    let name = "";
    let value = isCombinedOperator ? [] : "";
    valueArray.forEach((elm, index) => {
      let _currentValue = "";
      let _currentName = "";

      let fieldAlreadyExist = null;

      try {
        const valueObject = JSON.parse(elm.value);
        if (field.type === "date-range") {
          _currentValue = [];
          if (valueObject.fromDate?.value) {
            if (isCombinedOperator) {
              _currentValue.push(
                getLocalISODateString(valueObject.fromDate.value),
              );
            } else {
              _currentValue = getLocalISODateString(valueObject.fromDate.value);
            }

            _currentName = `From:${valueObject.fromDate?.name}`;
          }
          if (valueObject.toDate?.value) {
            if (isCombinedOperator) {
              _currentValue.push(
                getLocalISODateString(valueObject.toDate.value),
              );
              _currentName = `${_currentName} To:${valueObject.toDate?.name}`;
            } else {
              _currentValue = getLocalISODateString(valueObject.toDate.value);
              _currentName = `To:${valueObject.toDate?.name}`;
            }
          }
        } else {
          _currentValue = valueObject.value;
          _currentName = valueObject.name;
        }

        if (field.field === "CustomerId") {
          fieldAlreadyExist = fields.find(
            (elm) => elm.field === field.field && elm.value === _currentValue,
          );
          if (!fieldAlreadyExist) {
            getLocations(_currentValue);
          }
        } else if (field.field === "Category") {
          getSubCategory(valueObject.activityType, _currentValue);
        }
      } catch (e) {
        _currentValue = elm.value;
        _currentName = elm.value;
        if (field.field === "ActivityType" || field.field === "ServiceType") {
          fieldAlreadyExist = fields.find(
            (elm) => elm.field === field.field && elm.value === _currentValue,
          );
          if (!fieldAlreadyExist) {
            getCategory(_currentValue);
          }
        }
      }
      if (isCombinedOperator && field.type !== "date-range") {
        //only array works for this operators(multiple selection)
        value.push(_currentValue);
        name = `${name}${index === 0 ? "" : ","}${_currentName}`;
      } else {
        value = _currentValue;
        name = `${_currentName}`;
      }

      // else {

      //    operationsForm.setError("value", { message: "Field already selected" });
      // }
    });

    const fieldData = {
      logic: data.logic,
      operator: data.operator,
      field: field.field,
      label: field.label,
      name,
      value,
    };

    queryFields.push(fieldData);

    operationsForm.reset({ ...defaultQuery, operations: queryFields });
    filtersModified.current = true;
  };
  const getField = (field) => {
    if (field === "ActivityType") {
      return isCCA ? "ActivityType" : "ServiceType";
    } else if (field === "Category") {
      return isCCA || true ? "Category" : "FaultDetails";
    } else if (field === "SubCategory") {
      return isCCA || true ? "SubCategory" : "FaultDetails";
    } else if (field === "AssetId") {
      return isCCA ? "AssetId" : "ServicePointId";
    }
    return field;
  };
  const ValueField = useCallback(
    (field, disabled) => {
      const operationFieldString = operationsForm.watch("field");
      if (operationFieldString) {
        let lookupList = [];
        const operationFieldObject = JSON.parse(operationFieldString);
        if (
          operationFieldObject.type === "dropdown" ||
          operationFieldObject.type === "lookup" ||
          operationFieldObject.type === "boolean"
        ) {
          if (operationFieldObject.type === "dropdown") {
            lookupList = operationFieldObject?.options.map((elm) => ({
              label: `${elm.label}`,
              value: JSON.stringify({ value: elm.value, name: elm.label }),
            }));
          } else if (operationFieldObject.type === "boolean") {
            lookupList = [
              {
                label: "Yes",
                value: JSON.stringify({
                  value: "true",
                  name: "Yes",
                }),
              },
              {
                label: "No",
                value: JSON.stringify({
                  value: "false",
                  name: "No",
                }),
              },
            ];
          } else if (operationFieldObject.type === "lookup") {
            if (operationFieldObject.field === getField("RouteNo")) {
              lookupList = routesList?.data.map((elm) => ({
                label: elm.routeNo,
                value: JSON.stringify({
                  value: elm.routeNo,
                  name: elm.routeNo,
                }),
              }));
            } else if (
              operationFieldObject.field === getField("CashCenterId")
            ) {
              lookupList = cashCentersList?.data.map((elm) => ({
                label: elm.name,
                value: JSON.stringify({
                  value: elm.cashCenterId,
                  name: elm.name,
                }),
              }));
            } else if (
              operationFieldObject.field === getField("AssigneeId") ||
              operationFieldObject.field === getField("SecondaryAssigneeId")
            ) {
              lookupList = fieldTeam.map((elm) => ({
                label: `${elm.employeeId}-${elm.name}`,
                value: JSON.stringify({
                  value: elm.employeeId,
                  name: `${elm.employeeId}-${elm.name}`,
                }),
              }));
            } else if (
              operationFieldObject.field === getField("DispatcherId")
            ) {
              lookupList = dispatchersList?.data.map((elm) => ({
                label: `${elm.employeeId}-${elm.name}`,
                value: JSON.stringify({
                  value: elm.employeeId,
                  name: `${elm.employeeId}-${elm.name}`,
                }),
              }));
            } else if (
              operationFieldObject.field === getField("ResolutionCode")
            ) {
              lookupList = resolutionCodesRes?.data.map((elm) => ({
                label: elm.description,
                value: elm.description,
              }));
            } else if (operationFieldObject.field === getField("Reasons")) {
              lookupList = reasonsRes?.data.map((elm) => ({
                label: elm.description,
                value: elm.description,
              }));
            } else if (operationFieldObject.field === getField("Status")) {
              lookupList = statusList.map((elm) => ({
                label: elm.description,
                value: elm.description,
              }));
            } else if (operationFieldObject.field === getField("CustomerId")) {
              lookupList = customersList?.data.map((elm) => ({
                label: elm.name,
                value: JSON.stringify({
                  value: elm.customerId,
                  name: elm.name,
                }),
              }));
            } else if (operationFieldObject.field === getField("AssetId")) {
              lookupList = locationsList.map((elm) => ({
                label: elm.locationId,
                value: JSON.stringify({
                  name: elm.locationId,
                  value: elm.servicePointId,
                }),
              }));
            } else if (
              operationFieldObject.field === getField("ActivityType")
            ) {
              lookupList = activityTypesRes?.data.map((elm) => ({
                label: elm.description,
                value: elm.description,
              }));
            } else if (operationFieldObject.field === getField("Category")) {
              lookupList = categoryList.map((elm) => ({
                label: elm.description,
                value: JSON.stringify({
                  value: elm.description,
                  name: elm.description,
                  activityType: elm.activityType,
                }),
              }));
            } else if (operationFieldObject.field === getField("SubCategory")) {
              lookupList = subCategoryList.map((elm) => ({
                label: elm.description,
                value: JSON.stringify({
                  value: elm.description,
                  name: elm.description,
                  activityType: elm.activityType,
                  category: elm.category,
                }),
              }));
            } else if (
              operationFieldObject.field === getField("AssignmentGroup")
            ) {
              lookupList = getAssignmentGroupsList;
            } else if (operationFieldObject.field === getField("AgentId")) {
              lookupList = usersListRes.data.map((elm) => ({
                label: `${elm.employeeId}-${elm.name}`,
                value: JSON.stringify({
                  name: `${elm.employeeId}-${elm.name}`,
                  value: elm.employeeId,
                }),
              }));
            }
          }
          if (!lookupList?.find((elm) => elm.label === "All")) {
            lookupList?.unshift({
              label: "All",
              value: JSON.stringify({ value: "", name: "All" }),
            }) || [];
          }
          if (isCombinedOperator) {
            return (
              <FormControl>
                <KendoMultiselect
                  disabled={disabled}
                  style={
                    operationsForm.formState.errors.value
                      ? {
                          borderColor: "red",
                        }
                      : {}
                  }
                  textField="label"
                  dataItemKey="value"
                  value={field.value || null}
                  data={lookupList}
                  placeholder="Select Value"
                  popupSettings={{ className: "dashboard-container" }}
                  className="multiselect-shadcn "
                  onChange={(e) => {
                    field.onChange(e.value);
                  }}
                />
              </FormControl>
            );
          }

          return (
            <FormControl>
              <Combobox
                disabled={disabled}
                style={
                  operationsForm.formState.errors.value
                    ? {
                        borderColor: "red",
                      }
                    : {}
                }
                value={field.value || null}
                data={lookupList}
                placeholder="Select Value"
                setValue={(e) => {
                  field.onChange(e);
                }}
              />
            </FormControl>
          );
        } else if (operationFieldObject.type === "date-range") {
          let date = field.value ? JSON.parse(field.value) : null;

          return (
            <FormControl className="w-50%">
              <div className="flex flex-row gap-1 items-center">
                <p>From:&nbsp;</p>
                <DatePicker
                  disabled={disabled}
                  selectedDate={date?.fromDate?.value || null}
                  onSelectDate={(e) => {
                    if (e) {
                      if (date) {
                        date.fromDate = {
                          value: e,
                          name: moment(e).format("DD-MM-YYYY"),
                        };
                      } else {
                        date = {
                          fromDate: {
                            value: e,
                            name: moment(e).format("DD-MM-YYYY"),
                          },
                        };
                      }

                      field.onChange(JSON.stringify(date));
                    }
                  }}
                />
                {isCombinedOperator ? (
                  <>
                    <p>To:&nbsp;</p>
                    <DatePicker
                      disabled={disabled}
                      selectedDate={date?.toDate?.value || null}
                      onSelectDate={(e) => {
                        if (e) {
                          if (date) {
                            date.toDate = {
                              value: e,
                              name: moment(e).format("DD-MM-YYYY"),
                            };
                          } else {
                            date = {
                              toDate: {
                                value: e,
                                name: moment(e).format("DD-MM-YYYY"),
                              },
                            };
                          }

                          field.onChange(JSON.stringify(date));
                        }
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            </FormControl>
          );
        }
      }
      return (
        <FormControl>
          <DefaultInput
            {...field}
            disabled={disabled}
            className="border-secondary"
            style={
              operationsForm.formState.errors.value
                ? {
                    borderColor: "red",
                  }
                : {}
            }
          />
        </FormControl>
      );
    },
    [
      operationsForm.watch("field"),
      operationsForm.watch("operator"),
      cashCentersList,
      resolutionCodesRes,
      statusList,
      customersList,
      locationsList,
      activityTypesRes,
      categoryList,
      subCategoryList,
      getAssignmentGroupsList,
      usersListRes,
      routesList,
      fieldTeam,
      reasonsRes,
    ],
  );

  const onRemoveQuery = (index) => {
    const currentField = fields[index];
    const newFields = [...fields];
    newFields.splice(index, 1);
    if (currentField.field === "CustomerId") {
      const _locationsList = [];
      locationsList.forEach((elm) => {
        if (!currentField.value.includes(elm.customerId)) {
          _locationsList.push(elm);
        } else {
          const existingLocationIndex = newFields.findIndex(
            (_field) =>
              (_field.field === "AssetId" ||
                _field.field === "ServicePointId") &&
              _field.value === elm.servicePointId,
          );
          if (existingLocationIndex !== -1) {
            newFields.splice(existingLocationIndex, 1);
          }
        }
      });
      setLocationsList(_locationsList);
    } else if (
      currentField.field === "ActivityType" ||
      currentField.field === "ServiceType"
    ) {
      const _categoryList = [];
      categoryList.forEach((elm) => {
        if (!currentField.value.includes(elm.activityType)) {
          _categoryList.push(elm);
        } else {
          const existingCategoryIndex = newFields.findIndex(
            (_field) =>
              _field.field === "Category" && _field.value === elm.description,
          );

          if (existingCategoryIndex !== -1) {
            newFields.splice(existingCategoryIndex, 1);
          }

          const subCategoryIndex = newFields.findIndex(
            (item) =>
              item.field === "SubCategory" &&
              subCategoryList.find(
                (_field) =>
                  _field.category === elm.description &&
                  _field.activityType === currentField.value &&
                  item.value === _field.description,
              ),
          );
          if (subCategoryIndex !== -1) {
            newFields.splice(subCategoryIndex, 1);
          }
        }
      });
      setCategoryList(_categoryList);
    } else if (currentField.field === "Category") {
      const _categoryList = [];
      subCategoryList.forEach((elm) => {
        if (!currentField.value.includes(elm.category)) {
          _categoryList.push(elm);
        } else {
          const existingLocationIndex = newFields.findIndex(
            (_field) =>
              _field.field === "SubCategory" &&
              _field.value === elm.description,
          );
          if (existingLocationIndex !== -1) {
            newFields.splice(existingLocationIndex, 1);
          }
        }
      });
      setSubCategoryList(_categoryList);
    }

    filtersModified.current = true;
    if (!isOpen) {
      filterQueries(newFields);
    }

    operationsForm.reset({ ...defaultQuery, operations: newFields });
  };
  const filterFields = useMemo(() => {
    const _fields = [];
    filtersConfigurations?.filters?.forEach((elm) => {
      _fields.push({
        label: elm.label,
        value: JSON.stringify(elm),
      });
    });
    _fields.sort((a, b) => a.label.localeCompare(b.label));

    return _fields;
  }, [locationsList, filtersConfigurations]);

  function RenderFilterBadges() {
    return (
      <div className="flex mb-3 gap-2 flex-wrap items-end mt-2 max-h-[90px] overflow-y-scroll">
        {fields.map((elm, index) => {
          return (
            <Badge
              variant="secondary"
              className="gap-3 pr-1 cursor-pointer"
              key={`${elm.name}-${index}`}
            >
              {elm.logic === "and" ? "And" : "Or"}&nbsp;
              {elm.label}&nbsp;
              {logicObj[elm.operator]}&nbsp;
              {elm.name}
              <CircleX
                onClick={() => {
                  onRemoveQuery(index);
                }}
              />
            </Badge>
          );
        })}
      </div>
    );
  }

  const getSavedCriteriaList = useMemo(() => {
    const _fields = savedCriteria?.data.map((elm) => ({
      label: elm.searchName,
      value: elm.id,
    }));
    _fields?.unshift({ label: "Select Criteria", value: "" });
    return _fields || [];
  }, [savedCriteria]);

  const disableEditing = useMemo(() => {
    return false;
    // return selectedCriteria ? !isEditing : false;
  }, [isEditing, selectedCriteria]);

  const getFieldLogics = useMemo(() => {
    let _logics = [...LOGICS];
    if (operationsForm.watch("field")) {
      const fieldObj = JSON.parse(operationsForm.watch("field"));
      if (fieldObj.type !== "date-range") {
        _logics.pop();
      }
      if (fieldObj.allowedOperators) {
        _logics = fieldObj.allowedOperators.map((elm) => ({
          text: elm.display,
          id: elm.value,
        }));
      }
    }
    return _logics;
  }, [operationsForm.watch("field")]);

  const isCombinedOperator = useMemo(() => {
    const operator = operationsForm.watch("operator");
    return operator === "in" || operator === "not_in" || operator === "between";
  }, [operationsForm.watch("operator")]);

  const onFieldChange = (res) => {
    const resObject = JSON.parse(res);
    if (resObject.field === "CreateDateTime") {
      operationsForm.setValue("operator", "between");
    }
    if (resObject.default && !isCombinedOperator) {
      //set default option value
      if (resObject.type === "boolean") {
        const valueObj =
          resObject.default === "true"
            ? JSON.stringify({
                value: "true",
                name: "Yes",
              })
            : resObject.default === "false"
              ? JSON.stringify({
                  value: "false",
                  name: "No",
                })
              : "";
        operationsForm.setValue("value", valueObj);
      } else {
        const defaultOption = resObject.options.find(
          (elm) => elm.value === resObject.default,
        );
        if (defaultOption) {
          operationsForm.setValue(
            "value",

            JSON.stringify({
              value: defaultOption.value,
              name: defaultOption.label,
            }),
          );
        }
      }
    } else {
      operationsForm.resetField("value");
    }
    //by default operator is "equal" but it might not be present in allowed operators so we set its value to empty
    const getCurrentOperator = getFieldLogics.find(
      (elm) => elm.value === operationsForm.watch("operator"),
    );
    if (!getCurrentOperator) {
      operationsForm.setValue("operator", "");
    } else {
      operationsForm.resetField("operator");
    }
    const _logicObj = { ...logicObj };
    resObject?.allowedOperators.forEach((elm) => {
      _logicObj[elm.value] = elm.display;
    });
    setLogicObj(_logicObj);
  };
  return (
    <div className="flex flex-col gap-[4px] mb-3 w-full">
      {gettingTicketsConfig ||
      savingTicketsQuery ||
      gettingSavedCriteriaDetail ||
      gettingSavedCriteria ||
      deletingSearchCriteria ||
      updatingSequence ||
      loading ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="flex flex-row justify-between w-full">
        <div className="flex flex-row gap-2 w-full mr-2">
          <Dialog
            modal={false}
            open={isOpen}
            onOpenChange={(e) => {
              setIsOpen(e);
              if (e) {
                filtersModified.current = false;
              } else if (filtersModified.current) {
                filterQueries();
                filtersModified.current = false;
              }
            }}
          >
            <DialogTrigger asChild>
              <Button
                variant="secondary"
                className="w-max"
                title="Apply Filters"
              >
                <SlidersHorizontal />
              </Button>
            </DialogTrigger>
            <DialogContent
              onOpenAutoFocus={(e) => {
                e.preventDefault();
              }}
              className="max-w-[80vw] max-h-[90vh] h-[90vh] flex flex-col gap-2 overflow-y-scroll"
            >
              <DialogHeader>
                <DialogTitle className="mb-8">Dynamic Filtering</DialogTitle>
              </DialogHeader>

              <Form {...form}>
                <form
                  onSubmit={form.handleSubmit(onSubmit)}
                  className="space-y-8"
                >
                  <div className="flex flex-row justify-between items-end">
                    <FormField
                      control={form.control}
                      name="searchName"
                      rules={{ required: "Please Enter Config Name" }}
                      render={({ field }) => (
                        <FormItem>
                          <div className="flex flex-col gap-2">
                            <Label label="Name" isRequired />
                            <FormControl>
                              <DefaultInput
                                {...field}
                                className="w-[300px]"
                                disabled={disableEditing}
                                style={
                                  errors.searchName
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {errors ? (
                              errors.searchName ? (
                                <p className="text-destructive text-xs">
                                  {errors?.searchName.message ||
                                    "Please Select Name!"}
                                </p>
                              ) : (
                                <></>
                              )
                            ) : (
                              <></>
                            )}
                          </div>
                        </FormItem>
                      )}
                    />
                    <div className="flex flex-row gap-2 justify-end">
                      <SearchCriteriaSettings
                        searchCriteria={savedCriteria?.data || []}
                        updateCriteria={(filters) => {
                          updateSequence({
                            screen: ticketsType,
                            searchOrderList: filters.map((elm, index) => ({
                              id: elm.id,
                              order: index + 1,
                            })),
                          });
                        }}
                      />
                      {selectedCriteria ? (
                        <>
                          <Button
                            type="button"
                            variant="secondary"
                            onClick={() => {
                              resetPage();
                              navigate(getBaseUrl);
                            }}
                          >
                            New Query
                          </Button>
                          <Button
                            type="button"
                            variant="secondary"
                            onClick={() => {
                              deleteSearchCriteria(selectedCriteria);
                            }}
                          >
                            Delete
                          </Button>
                          {/* <Button
                            type="button"
                            variant="secondary"
                            onClick={() => {
                              setIsEditing(true);
                            }}
                          >
                            Edit
                          </Button> */}
                        </>
                      ) : null}

                      <Button
                        type="submit"
                        variant="secondary"
                        disabled={disableEditing}
                      >
                        {selectedCriteria ? "Update" : "Save"}
                      </Button>
                      {form.watch("saveForOthers") ? (
                        <Dialog
                          modal={false}
                          open={showSaveModal}
                          onOpenChange={(e) => {
                            setShowSaveModal(e);
                          }}
                        >
                          <DialogTrigger asChild>
                            <Button
                              type="button"
                              variant="secondary"
                              disabled={disableEditing}
                              onClick={() => {
                                setShowSaveModal(true);
                              }}
                            >
                              Change Users
                            </Button>
                          </DialogTrigger>
                          <DialogContent
                            onOpenAutoFocus={(e) => {
                              e.preventDefault();
                            }}
                            className="max-w-[40vw] max-h-[90vh] h-[90vh] flex flex-col gap-2 overflow-y-scroll"
                          >
                            <DialogHeader>
                              <DialogTitle className="mb-8">
                                Select Other Users
                              </DialogTitle>
                            </DialogHeader>
                            <FormField
                              control={form.control}
                              name="users"
                              render={({ field }) => (
                                <FormItem>
                                  <div className="flex flex-col gap-2">
                                    <Label label="User" />
                                    <FormControl>
                                      <KendoMultiselect
                                        value={field.value || null}
                                        className="multiselect-shadcn "
                                        data={usersListRes.data.map((elm) => ({
                                          label: `${elm.employeeId}-${elm.name}`,
                                          value: elm.id,
                                        }))}
                                        textField="label"
                                        dataItemKey="value"
                                        placeholder="Select User"
                                        filterable
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                        }}
                                      />
                                    </FormControl>
                                  </div>
                                </FormItem>
                              )}
                            />
                            <FormField
                              control={form.control}
                              name="assignmentGroups"
                              render={({ field }) => (
                                <FormItem>
                                  <div className="flex flex-col gap-2 mt-2">
                                    <Label label="Assignment Group" />
                                    <FormControl>
                                      <KendoMultiselect
                                        value={field.value || null}
                                        className="multiselect-shadcn "
                                        data={getOtherAssignmentGroups}
                                        textField="label"
                                        dataItemKey="value"
                                        placeholder="Select Assignment"
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                        }}
                                      />
                                    </FormControl>
                                  </div>
                                </FormItem>
                              )}
                            />
                            <div className="flex w-full justify-end items-end">
                              <Button
                                type="button"
                                variant="secondary"
                                onClick={() => {
                                  setShowSaveModal(false);
                                }}
                              >
                                Close
                              </Button>
                            </div>
                          </DialogContent>
                        </Dialog>
                      ) : null}
                    </div>
                  </div>
                  <div className="flex flex-row gap-4 mt-2">
                    <FormField
                      control={form.control}
                      name="saveForUser"
                      render={({ field }) => (
                        <FormItem>
                          <div className="flex flex-row gap-2 items-center">
                            <Checkbox
                              id="saveForUser"
                              checked={field.value}
                              onCheckedChange={(val) =>
                                field.onChange(Boolean(val))
                              }
                            />
                            <label
                              htmlFor="saveForUser"
                              className="text-sm font-medium"
                            >
                              Save For Current User
                            </label>
                          </div>
                        </FormItem>
                      )}
                    />
                    {selectedCriteria ? null : (
                      <FormField
                        control={form.control}
                        name="saveForOthers"
                        render={({ field }) => (
                          <FormItem>
                            <div className="flex flex-row gap-2 items-center">
                              <Checkbox
                                id="saveForOthers"
                                checked={field.value}
                                onCheckedChange={(val) => {
                                  field.onChange(Boolean(val));
                                  if (val) {
                                    setShowSaveModal(true);
                                  }
                                }}
                              />
                              <label
                                htmlFor="saveForOthers"
                                className="text-sm font-medium"
                              >
                                Save For Other Users
                              </label>
                            </div>
                          </FormItem>
                        )}
                      />
                    )}
                  </div>

                  <Form {...operationsForm}>
                    <form className="flex flex-col gap-2">
                      {fields.length > 0 ? (
                        <Grid data={fields}>
                          <GridColumn
                            title="Logic"
                            field="logic"
                            cell={({ dataItem }) => (
                              <td className="k-table-td">
                                {dataItem.logic === "and" ? "AND" : "OR"}
                              </td>
                            )}
                          />
                          <GridColumn title="Field" field="label" />
                          <GridColumn
                            title="Operator"
                            field="operator"
                            cell={({ dataItem }) => {
                              return (
                                <td className="k-table-td">
                                  {logicObj[dataItem.operator]}
                                </td>
                              );
                            }}
                          />
                          <GridColumn title="Value" field="name" />

                          <GridColumn
                            cell={({ dataIndex }) => (
                              <td>
                                <div className="flex items-center justify-center w-full">
                                  <Button
                                    variant="outline"
                                    title="Delete"
                                    disabled={disableEditing}
                                    onClick={() => onRemoveQuery(dataIndex)}
                                  >
                                    <Trash2
                                      color="red"
                                      style={{ width: "14px" }}
                                    />
                                  </Button>
                                </div>
                              </td>
                            )}
                          />
                        </Grid>
                      ) : null}

                      <div className="flex flex-row gap-1 mt-2">
                        <div className="flex flex-col gap-2">
                          <Label
                            label="TEST"
                            style={{ visibility: "hidden" }}
                          />

                          <div className="flex flex-row gap-1">
                            <Button
                              type="button"
                              disabled={disableEditing}
                              variant={
                                operationsForm.watch("logic") === "and"
                                  ? "secondary"
                                  : "outline"
                              }
                              onClick={() => {
                                operationsForm.setValue("logic", "and");
                              }}
                            >
                              AND
                            </Button>
                            <Button
                              type="button"
                              disabled={disableEditing}
                              variant={
                                operationsForm.watch("logic") === "or"
                                  ? "secondary"
                                  : "outline"
                              }
                              onClick={() => {
                                operationsForm.setValue("logic", "or");
                              }}
                            >
                              OR
                            </Button>
                          </div>
                        </div>

                        <FormField
                          control={operationsForm.control}
                          name="field"
                          rules={{ required: "Please Select Field" }}
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Field" isRequired />

                              <FormControl>
                                <Combobox
                                  className="border-secondary"
                                  disabled={disableEditing}
                                  style={
                                    operationsForm.formState.errors?.field
                                      ? {
                                          borderColor: "red",
                                        }
                                      : {}
                                  }
                                  value={field.value || null}
                                  data={filterFields}
                                  placeholder="Select Field"
                                  setValue={(res) => {
                                    onFieldChange(res);

                                    field.onChange(res);
                                  }}
                                />
                              </FormControl>
                              {operationsForm.formState.errors ? (
                                operationsForm.formState.errors.field ? (
                                  <p className="text-destructive text-xs">
                                    {operationsForm.formState.errors.field
                                      .message || "Please Select Field!"}
                                  </p>
                                ) : (
                                  <></>
                                )
                              ) : (
                                <></>
                              )}
                            </FormItem>
                          )}
                        />
                        <FormField
                          control={operationsForm.control}
                          name="operator"
                          rules={{ required: "Please Select Query" }}
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Query" isRequired />
                              <Select
                                onValueChange={(e) => {
                                  if (
                                    e === "in" ||
                                    e === "not_in" ||
                                    e === "between"
                                  ) {
                                    operationsForm.setValue("value", "");
                                  }

                                  field.onChange(e);
                                }}
                                value={field.value}
                                disabled={disableEditing}
                              >
                                <FormControl>
                                  <SelectTrigger
                                    className="border-secondary  w-[150px] "
                                    disabled={disableEditing}
                                    style={
                                      operationsForm.formState.errors?.operator
                                        ? {
                                            borderColor: "red",
                                          }
                                        : {}
                                    }
                                  >
                                    <SelectValue placeholder="Select Logic" />
                                  </SelectTrigger>
                                </FormControl>
                                <SelectContent>
                                  {getFieldLogics.map((elm) => (
                                    <SelectItem value={elm.id} key={elm.id}>
                                      {elm.text}
                                    </SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                              {operationsForm.formState.errors ? (
                                operationsForm.formState.errors.operator ? (
                                  <p className="text-destructive text-xs">
                                    {operationsForm.formState.errors?.operator
                                      .message || "Please Select Query!"}
                                  </p>
                                ) : (
                                  <></>
                                )
                              ) : (
                                <></>
                              )}
                            </FormItem>
                          )}
                        />
                        <FormField
                          control={operationsForm.control}
                          name="value"
                          rules={{
                            required: "Please Enter Value",
                            validate: () => {
                              const data = operationsForm.getValues();
                              const _field = JSON.parse(data.field);
                              if (
                                isCombinedOperator &&
                                _field?.type === "date-range" &&
                                data.value
                              ) {
                                const valueObj = JSON.parse(data.value);
                                if (valueObj?.toDate && valueObj?.fromDate) {
                                  return true;
                                }
                                return "Please select both dates";
                              }
                              return true;
                            },
                          }}
                          render={({ field }) => (
                            <FormItem>
                              <div className="flex flex-col gap-2">
                                <Label label="Value" isRequired />
                                {ValueField(field, disableEditing)}

                                {operationsForm.formState.errors ? (
                                  operationsForm.formState.errors.value ? (
                                    <p className="text-destructive text-xs">
                                      {operationsForm.formState.errors.value
                                        .message || "Please Select Value!"}
                                    </p>
                                  ) : (
                                    <></>
                                  )
                                ) : (
                                  <></>
                                )}
                              </div>
                            </FormItem>
                          )}
                        />
                        <div className="flex flex-col gap-2">
                          <Label
                            label="TEST"
                            style={{ visibility: "hidden" }}
                          />
                          <Button
                            type="button"
                            variant="outline"
                            title="Add"
                            disabled={disableEditing}
                            onClick={operationsForm.handleSubmit(addQuery)}
                          >
                            <Plus />
                          </Button>
                        </div>
                        <div className="flex flex-col gap-2">
                          <Label
                            label="TEST"
                            style={{ visibility: "hidden" }}
                          />
                          <Button
                            type="button"
                            variant="outline"
                            title="Refresh"
                            disabled={disableEditing}
                            onClick={() => {
                              const operations = [...fields];
                              operationsForm.reset({
                                ...defaultQuery,
                                operations,
                              });
                            }}
                          >
                            <RefreshCcw />
                          </Button>
                        </div>
                      </div>
                    </form>
                  </Form>
                </form>
              </Form>
            </DialogContent>
          </Dialog>

          <ColumnsSettings ticketsType={ticketsType} />
          <div className="min-w-[200px]">
            <Select
              onValueChange={(e) => {
                setSelectedDate(e);
              }}
              // defaultValue={field.value}
              value={selectedDate}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {periodList.map((elm, index) => (
                  <SelectItem key={index} value={elm.value}>
                    {elm.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="w-full">
            <DefaultInput
              value={selectedFilter}
              placeholder="Search: Task no, Case No, Status, Activity Type, Category, Sub Category, Bank Reference No, Assignment Group, Route No, Assigned To"
              title="Search: Task no, Case No, Status, Activity Type, Category, Sub Category, Bank Reference No, Assignment Group, Route No, Assigned To"
              onChange={(e) => setSelectedFilter(e.target.value)}
            />
          </div>
        </div>
        <div className="flex flex-row gap-2">
          {/* <CreateDropdown /> */}
          <div className="w-[200px]">
            <Combobox
              disabled={!savedCriteria}
              className="border-secondary "
              value={selectedCriteria}
              data={getSavedCriteriaList}
              placeholder="Select Favorites"
              setValue={(res) => {
                if (res) {
                  const currentItem = getSavedCriteriaList.find(
                    (elm) => elm.value === res,
                  );
                  if (currentItem) {
                    form.setValue("searchName", currentItem.label);
                  }

                  setSelectedDate("today");
                  setSelectedCriteria(res);
                  getSaveCriteriaDetails(res);
                } else {
                  resetPage();
                }
              }}
            />
          </div>{" "}
          {exportExcel ? (
            <Button
              variant="secondary"
              disabled={exportingExcel}
              onClick={onExcelExport}
            >
              {exportingExcel ? <KendoLoader themeColor="light" /> : null}
              <FaFileExcel style={{ marginRight: "8px" }} />
              Export
            </Button>
          ) : null}
          <Button variant="secondary" onClick={onRefresh} title="Refresh List">
            <RefreshCcw style={{ marginRight: "0px", width: "16px" }} />
          </Button>
        </div>
      </div>
      {!isCCA ? (
        <BulkAssignment
          fieldTeam={fieldTeam}
          routesList={routesList?.data || []}
          selectedRequests={selectedRequests}
          assignTeam={assignTeam}
          isSecondaryAssigneeRequired={isSecondaryAssigneeRequired}
          hideSupervisor={hideSupervisor}
        />
      ) : null}

      <RenderFilterBadges />
    </div>
  );
}
